import { CartState, SelectedQuantitiesMap } from "../interfaces";
import { CartQuery } from "../../lib/api";
import { DefaultCartProcessingStrategy } from "./DefaultCartProcessingStrategy";

export class NubuCartProcessingStrategy extends DefaultCartProcessingStrategy {
  supports(cart: CartQuery['Cart']) {
    return cart.theme === 'NUBU';
  }

  incrementQuantity(productId: string, state: CartState) {
    return this.modifyQuantity(state, productId, state.discountsApplied ? 2 : 1);
  }

  decrementQuantity(productId: string, state: CartState) {
    return this.modifyQuantity(state, productId, state.discountsApplied ? -2 : -1);
  }

  onDiscountApplied(state: CartState) {
    const productIds = Object.keys(state.selectedQuantities);

    let updatedQuantities: SelectedQuantitiesMap = {};
    for (let id of productIds) {
      updatedQuantities[id] = state.selectedQuantities[id] * 2;
    }

    return { selectedQuantities: { ...updatedQuantities } };
  }
}
